export const types = {
    // Sync
    SHOW_UNSUBSCRIBED_USER_MODAL: "SHOW_UNSUBSCRIBED_USER_MODAL",
    HIDE_UNSUBSCRIBED_USER_MODAL: "HIDE_UNSUBSCRIBED_USER_MODAL",
};
